import { fetchFxRates } from '../util/api';
import { CURRENT_USER_SHOW_SUCCESS } from './user.duck';
import { updateProfile, UPDATE_PROFILE_SUCCESS } from '../containers/ProfileSettingsPage/ProfileSettingsPage.duck';

// ================ Action types ================ //
export const SET_SELECTED_CURRENCY = 'app/currency/SET_SELECTED_CURRENCY';
export const SET_FX_RATES = 'app/currency/SET_FX_RATES';

// ================ Reducer ================ //
const initialState = {
  selectedCurrency: 'AED',
  fxRates: null,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case SET_SELECTED_CURRENCY:
      return { ...state, selectedCurrency: payload };
    case SET_FX_RATES:
      return { ...state, fxRates: payload };
    case CURRENT_USER_SHOW_SUCCESS:
    case UPDATE_PROFILE_SUCCESS: {
      const user = payload;
      const protectedData = user?.attributes?.profile?.protectedData || {};
      const savedCurrency = protectedData.currency;
      const isExplicit = protectedData.currencyExplicitlySet;
      if (savedCurrency && (isExplicit || savedCurrency !== 'USD') && savedCurrency !== state.selectedCurrency) {
        return { ...state, selectedCurrency: savedCurrency };
      }
      return state;
    }
    default:
      return state;
  }
}

// ================ Action creators ================ //
export const setSelectedCurrency = currency => (dispatch, getState) => {
  dispatch({
    type: SET_SELECTED_CURRENCY,
    payload: currency,
  });

  const state = getState();
  const currentUser = state.user?.currentUser;
  if (currentUser) {
    const currentProtectedData = currentUser.attributes?.profile?.protectedData || {};
    if (currentProtectedData.currency !== currency || !currentProtectedData.currencyExplicitlySet) {
      dispatch(
        updateProfile({
          protectedData: {
            currency: currency,
            currencyExplicitlySet: true,
          },
        })
      ).catch(err => {
        console.error('Failed to update currency in user profile:', err);
      });
    }
  }
};

export const setFxRates = rates => ({
  type: SET_FX_RATES,
  payload: rates,
});

// ================ Thunks ================ //
export const loadFxRates = () => async (dispatch, getState) => {
  try {
    const res = await fetchFxRates();
    const rates = res?.data?.rates || res?.rates;
    if (rates) {
      dispatch(setFxRates(rates));
    }
  } catch (err) {
    console.error('Failed to load FX rates in redux:', err);
  }
};
